import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {Mission} from "./model/mission.type";
import {Observable} from "rxjs/Observable";
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import {MissionService} from "./services/mission.service";

@Component({
  selector: 'vb-mission',
  templateUrl: './mission.component.html',
  styleUrls: ['./mission.component.css']
})
export class MissionComponent implements OnInit, AfterViewInit {

  title = 'Einsatz';

  @Input()
  showCtrls: boolean = true;

  @Input()
  readOnly: boolean = false;

  @Input()
  missionData: Mission = <Mission>{};

  @Output()
  onMissionDataChanged: EventEmitter<Mission> = new EventEmitter<Mission>();

  @ViewChild('focusField') private focusField: ElementRef;

  missionDataObserver: Observable<Mission>;

  missions$: Observable<Mission[]>;

  missionForm: FormGroup;
  missionNrCtrl: AbstractControl;
  missionDateCtrl: AbstractControl;

  constructor(private route: ActivatedRoute,
              private missionService: MissionService,
              private fb: FormBuilder) {

  }

  ngOnInit() {

    /*
     this.missionService.setActivatedRoute(this.route);
     this.missionDataObserver = Observable.of(this.missionData);
     */

    //this.missions$ = this.missionService.getModels();

    this.missionForm = this.fb.group({
      'missionNumber': [null, Validators.required],
      'missionDate': [null, Validators.required]
    });

    this.missionNrCtrl = this.missionForm.controls['missionNumber'];
    this.missionDateCtrl = this.missionForm.controls['missionDate'];

    //TODO: Observe the local variable instead of the form input controls
    this.missionForm.valueChanges.subscribe(
      c => this.onMissionDataChanged.emit(this.missionData)
    );
  }

  ngAfterViewInit() {
    if (this.focusField.nativeElement) {
      <HTMLInputElement>(this.focusField.nativeElement).focus();
    }
  }

  onSubmit() {
    //this.missionService.createModel(this.missionData);
  }


}



// WEBPACK FOOTER //
// ./src/app/mission/mission.component.ts